import type { ClaimDealPayload, TClaimDealUtilReturn } from './deals.types';
import { DealKind } from 'shared/types';
import { ErrorMessages } from 'shared/constants/errorMessages';
import { logger } from 'shared/utils/logger/logger';
import { logReturnedError } from 'shared/utils/logger/logReturnedError';

const handleNetworkError = <T>(fallback: T): T => fallback;

export const claimDeal = async (
    dealKind: DealKind,
    dealId: string,
    payload: ClaimDealPayload
): Promise<TClaimDealUtilReturn> => {
    try {
        const response = await fetch('/api/v2/deals/claim', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ dealKind, dealId, payload }),
        });

        const res = await response.json();
        if (res.error) {
            logReturnedError(
                'Claim deal request returned error',
                'Client:claimDeal',
                {
                    dealKind,
                    dealId,
                    error: res.error,
                }
            );
        }
        return res as Awaited<TClaimDealUtilReturn>;
    } catch (error) {
        logger.error('Claim deal request threw', 'Client:claimDeal', {
            dealKind,
            dealId,
            error,
        });
        return handleNetworkError({ error: ErrorMessages.NETWORK_ISSUE });
    }
};
